export type {
  CommentsParentDocumentRootQuery,
  CommentsParentDocumentRootQueryVariables,
} from './__generated__/comments-redirect.graphql'
export { COMMENTS_PARENT_DOCUMENT_ROOT_QUERY } from './comments-redirect'
